import React from "react";
import HeaderV2 from "./HeaderV2";
import FooterV2 from "./FooterV2";
import HeroV2 from "./sections/HeroV2";
import WhoWeAreV2 from "./sections/WhoWeAreV2";
import JurisdictionsV2 from "./sections/JurisdictionsV2";
import WhyUAEV2 from "./sections/WhyUAEV2";
import ProcessV2 from "./sections/ProcessV2";
import ServicesV2 from "./sections/ServicesV2";
import JourneyV2 from "./sections/JourneyV2";
import AgenciesV2 from "./sections/AgenciesV2";
import BlogsV2 from "./sections/BlogsV2";
import FAQV2 from "./sections/FAQV2";
import CTAV2 from "./sections/CTAV2";
import InlineCTA from "./sections/InlineCTA";
import useSmoothScroll from "../../hooks/useSmoothScroll";

export default function HomeV2() {
  useSmoothScroll(true);
  return (
    <div data-testid="v2-page" className="bg-white">
      <HeaderV2 />
      <main>
        <HeroV2 />
        <WhoWeAreV2 />
        <InlineCTA
          eyebrow="Free 20-minute consultation"
          title="Get a tailored Mainland-vs-Freezone roadmap from a senior advisor."
          buttonLabel="Book my call"
        />
        <JurisdictionsV2 />
        <WhyUAEV2 />
        <InlineCTA
          variant="dark"
          eyebrow="Ready to incorporate?"
          title="Receive a transparent written quote within 24 hours."
          buttonLabel="Request a quote"
        />
        <ProcessV2 />
        <ServicesV2 />
        <JourneyV2 />
        <AgenciesV2 />
        <InlineCTA
          eyebrow="Banking made simple"
          title="Open a UAE corporate account with a bank-ready, audit-grade file."
          buttonLabel="Open my account"
          service="banking"
        />
        <BlogsV2 />
        <FAQV2 />
        <CTAV2 />
      </main>
      <FooterV2 />
    </div>
  );
}
